import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import md5 from "md5";
import { RotateSpinLoader } from "react-css-loaders2";

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import HeartIcon from "react-icons/lib/fa/heartbeat";
import CogIcon from "react-icons/lib/fa/cog";
import LogoutIcon from "react-icons/lib/fa/sign-out";
import HamburgerIcon from "react-icons/lib/md/dehaze";

import routes from "../../routes";

import { logout } from "../../auth/actions";
import { sidebarToggle } from "../../app/actions";

class Header extends Component {
  render() {
    const { viewer, logout, history, sidebarToggle } = this.props;

    const emailMD5 = viewer && md5(viewer.email);
    return (
      <Wrapper>
        <SidebarControl onClick={sidebarToggle}>
          <HamburgerIcon size="40" />
        </SidebarControl>
        <Logo href={routes.offers}>
          <StyledHeartIcon size="40" />
          <LogoText>OpiekujSię.pl</LogoText>
        </Logo>
        <Profile>
          <UncontrolledDropdown {...!viewer && { toggle: () => {} }}>
            <DropdownToggle tag="div">
              {viewer ? (
                <div>
                  <Email>{viewer && viewer.email}</Email>
                  <Image
                    src={`https://www.gravatar.com/avatar/${emailMD5}?s=160&d=mm`}
                  />
                </div>
              ) : (
                <RotateSpinLoader color="#000" size={2} />
              )}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={() => history.push(routes.settings)}>
                <CogIcon size="15" />
                <ItemText>Ustawienia</ItemText>
              </DropdownItem>
              <DropdownItem onClick={logout}>
                <LogoutIcon size="15" />
                <ItemText>Wyloguj się</ItemText>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Profile>
      </Wrapper>
    );
  }
}

const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  height: 55px;
  background-color: #fff;
  border-bottom: 1px solid #c2cfd6;
  flex-direction: row;
  padding: 0;
  margin: 0;
  z-index: 1000;
  user-select: none;
`;

const SidebarControl = styled.div`
  display: none;
  height: 55px;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;

  @media (max-width: 800px) {
    display: flex;
    flex: 1;
  }
`;

const StyledHeartIcon = styled(HeartIcon)`color: #ea4335;`;

const Logo = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 260px;
  height: 55px;
  margin-right: 0;

  &:hover {
    text-decoration: none;
  }

  @media (max-width: 800px) {
    flex: 1;
    margin-left: 10px;
  }
`;

const LogoText = styled.span`
  color: #5a5a5a;
  font-weight: 600;
  font-size: 16px;
  margin-left: 11px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const Profile = styled.div`
  display: flex;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;

  @media (max-width: 800px) {
    justify-content: flex-end;
    margin-right: 10px;
    flex: 1;
  }
`;
const Email = styled.span`
  font-size: 14px;
  margin-right: 12px;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Image = styled.img`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;

const ItemText = styled.span`
  font-size: 14px;
  margin-left: 10px;
`;

Header = connect(
  state => ({
    viewer: state.auth.viewer
  }),
  { logout, sidebarToggle }
)(Header);

Header = withRouter(Header);
export default Header;



// WEBPACK FOOTER //
// ./src/components/Site/Header.js